// extracted by mini-css-extract-plugin
export default {"badge":"primeBadge_badge__L1m+y"};